<template>
  <div v-loading="loading">
    <el-page-header @back="goBack" class="page_header" :content="title"></el-page-header>
    <span>账号：{{ username }}</span>
    <template>
      <div class="title">{{ title }}</div>
      <el-table
          v-if="disease_info.length > 0"
          border
          :data="disease_info"
          style="width: 100%">
        <el-table-column
            prop="disease_name"
            label="疾病名称"
            align="center"
            >
        </el-table-column>
        <el-table-column
            prop="count"
            label="次数"
            align="center"
            >
        </el-table-column>
      </el-table>
      <div v-else>
        <span>暂无疾病因素</span>
      </div>
    </template>
  </div>
</template>

<script>
import {get_disease_number_data} from "@/api/DataSearch";
import { number } from "echarts";

export default {
  name: "disease_number",
  props: {
    title: {
      type: String
    },
    username: {
      type: String
    },
    name: {
      type: String
    },
    user_id: {
      type: number
    }
  },
  data() {
    return {
      disease_info: {
        name: '',
        data: []
      },
      loading: false
    }
  },
  created() {
    // console.log(this.name, this.user_id, this.username, this.title);
    this.get_disease_number_data()
    // this.loading = true
    // get_disease_number_data(this.conversation_ids).then(res => {
    //   this.loading = false
    //   const {data} = res
    //   if (data['code'] === 200) {
    //     const disease_info = []
    //     try {
    //       console.log(disease_info)
    //       for (const key in data['disease_type'][this.name]['disease']) {
    //         disease_info.push({
    //           name: key,
    //           number: data['disease_type'][this.name]['disease'][key]
    //         })
    //       }
    //     } catch (e) {
    //       throw e
    //     }
    //     this.$set(this.disease_info, 'data', disease_info)
    //   }
    // })
  },
  methods: {
    get_disease_number_data() {
        this.loading = true
        const params = {
          user_id: this.user_id,
          disease_type: this.name
        }
       get_disease_number_data(params).then(res => {
          this.loading = false
          // console.log(res, "res");
          
          const {data} = res
          if (data['code'] === 200) {
            this.disease_info = data.data
          }
        })
    },
    goBack() {
      this.$router.push('/bec/static')
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.page_header {
  margin-bottom: 20px;
}

.title {
  border-left: 5px solid #983CC9;
  margin: 30px 0;
  padding-left: 20px;
}

.link {
  color: #266FFF;
  cursor: pointer;
}
</style>